// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchHomeDataIfNeeded } from '../../../redux/modules/home';
import { fetchUpcomingCatalogsIfNeeded } from '../../../redux/modules/upcomingCatalogs';
import { recordAnalyticsForHomePageView } from '../../../redux/modules/analytics';

const MAX_TODAY_AUCTIONS = 50;

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return Promise.all([
        dispatch(fetchHomeDataIfNeeded()),
        dispatch(fetchUpcomingCatalogsIfNeeded(MAX_TODAY_AUCTIONS, true)),
    ]).then(() => {
        return dispatch(recordAnalyticsForHomePageView());
    });
};
